export const styles = {
  senderInputLabels: {
    color: "text.primary",
  },
  formTextInput: {
    "& .MuiInputBase-root": {
      boxShadow: "4px 4px 4px 0px #0C38911A",
      border: "1px solid events.grayShade1",
    },
  },
  textAreaRoot: {
    "& .MuiInputBase-root": {
      boxShadow: "4px 4px 4px 0px #0C38911A",
      border: "1px solid red",
    },
  },
  textAreaLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: "events.lightBlack",
  },
  container: {
    mt: 4,
  },
  paper: {
    p: 2,
    mb: 3,
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    borderRadius: "8px",
    boxShadow: "4px 4px 4px 0px rgba(12, 56, 145, 0.1)",
    background: "rgba(229, 248, 251, 1)",
  },
  icon: {
    color: "primary.main",
    fontSize: "24px",
  },
  buttons: {
    display: "flex",
    gap: 2,
    mt: 2,
  },
  previewButton: {
    mt: 1,
  },
  imageUploaderContainer: {
    width: "100%",
    maxWidth: "600px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "200px",
    gap: 2,
  },
  inputLabel: {
    mb: 1,
  },
  mediaToggle: {
    mb: 2,
  },
  uploadCaption: {
    mt: 1,
    color: "text.secondary",
    fontSize: "0.75rem",
  },
  bottomButtons: {
    display: "flex",
    gap: 2,
    pt: 2,
  },
};
